import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import { IJobAssemblySessionResponse } from "../models/Job";
import {
  FinishDepollutionSessionRequest,
  PauseDepollutionSessionRequest,
  StartDepollutionSessionRequest,
} from "../models/Depollution";

export default function useDepollutionSession(depollutionId?: string) {
  const { get, post } = useApiHelper();
  const queryClient = useQueryClient();

  const sessions = useQuery({
    queryKey: ["depollutionSessions", depollutionId],
    queryFn: () => get<IJobAssemblySessionResponse>(`/JobAssemblySession/depollution/${depollutionId}`),
    enabled: !!depollutionId,
  });

  const invalidate = () => {
    queryClient.invalidateQueries(["depollutionSessions", depollutionId]);
    queryClient.invalidateQueries(["depollution", depollutionId]);
  };

  const startSession = useMutation(
    (body: StartDepollutionSessionRequest) => post("/JobAssemblySession/depollution/start", body),
    {
      onSuccess: () => {
        invalidate();
      }
    }
  );

  const pauseSession = useMutation(
    (body: PauseDepollutionSessionRequest) => post("/JobAssemblySession/depollution/pause", body),
    {
      onSuccess: () => {
        invalidate();
      }
    }
  );

  const finishSession = useMutation(
    (body: FinishDepollutionSessionRequest) => post("/JobAssemblySession/depollution/finish", body),
    {
      onSuccess: () => {
        invalidate();
      }
    }
  );

  return {
    sessions,
    startSession,
    pauseSession,
    finishSession
  };
}
